import "./App.css";
import useLiffAuth from "./hooks/useLiff";
import usePageTracking from "./hooks/usePageTracking";
import { setLastTouchUTMFromURL, migrateLegacyUTMKeys } from "./utils/utm";

import {
  BrowserRouter as Router,
  Navigate,
  Route,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useState, useEffect, useRef, createElement } from "react";
import { TranslateProvider } from "./context/TranslateProvider";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enTranslator from "./locales/en/translation.json";
import thTranslator from "./locales/th/translation.json";

import {
  withAuthRedirect,
  withAuthBigPointRedirect,
} from "./components/auth/withAuthRedirect";

import ProfileHeader from "./components/header/ProfileHeader";
import Footer from "./components/footer/Footer";
import MyCoupons from "./components/my-coupons/MyCoupons";
import MyCouponDetail from "./components/my-coupons/MyCouponDetail";
import MyBigpoint from "./components/my-bigpoint/my-bigpoint";
import PointHistory from "./components/my-bigpoint/PointHistory";
import Main from "./components/main";
import Login from "./components/section/Login";
import Register from "./components/section/Register";
import Promotion from "./components/section/Promotion";
//import Blogs from "./components/section/Blogs";
import Missions from "./components/missions/missions";
import Scan from "./components/my-bigpoint/scan";
//import BlogDetail from "./components/section/BlogDetail";
import LoadingBar from "./components/LoadingBar";
import MissionCateDetail from "./components/missions/missionsCateDetail";
import MissionDetail from "./components/missions/missionsDetail";
import RedeemCouponModal from "./components/bc-coupons/RedeemCouponModal";
import { LiffProfileProvider } from "./context/LiffProfileContext";
import OtpPage from "./components/otp/OtpPage";
import SuccessBindingForm from "./components/user/SuccessBindingForm";
import BcCoupons from "./components/bc-coupons/BcCoupons";
import BcCouponDetail from "./components/bc-coupons/BcCouponDetail";
//
import CampaignDetail from "./components/campaign/CampaignDetail";
//import Catalog from "./components/e-catalog/Catalog";

import CatalogList from "./components/e-catalog/CatalogList";
import CatalogViewer from "./components/e-catalog/CatalogViewer";

import BlogsList from "./components/blogs/BlogsList";
import BlogsCategory from "./components/blogs/BlogsCatagory";
import BlogsDetail from "./components/blogs/BlogsDetail";
import StoriesRedirect from "./components/blogs/StoriesRedirect";
import { STORIES_REDIRECT_ENABLED } from "./config/config";

import Horoscope from "./components/horoscope/Horoscope";
import Horoscope2 from "./components/horoscope/Horoscope_old";

import LuckyName from "./components/horoscope/LuckyName";
import LuckyNameResult from "./components/horoscope/LuckyNameResult";

import Ascendant from "./components/horoscope/Ascendant";
import AscendantResult from "./components/horoscope/AscendantResult";

import TarotTopicPage from "./components/horoscope/TarotTopicPage";
import TarotPickOnePage from "./components/horoscope/TarotPickOnePage";
import TarotResultPage from "./components/horoscope/TarotResultPage";

import TarotPickLovePage from "./components/horoscope/TarotPickLovePage";
import TarotResultLovePage from "./components/horoscope/TarotResultLovePage";

import TarotPickThreePage from "./components/horoscope/TarotPickThreePage";
import TarotResultCarousel from "./components/horoscope/TarotResultCarousel";

import IsAuthLine from "./components/section/IsAuthLine";
import LogoutPage from "./components/section/LogoutPage";

import VideoFeed from "./components/video/VideoFeed";


import Survey from "./components/survey/survey";
import LineSticker from "./components/section/LineSticker";

import GameSupergirls from "./components/game-supergirls/GameSupergirls";
import RewardScreen from "./components/game-supergirls/RewardScreen";
import GameRewards from "./components/game-supergirls/Rewards";
import MuteluApp from "./components/game-mutelu/app/MuteluApp";



import GameFortuneCardHome from "./components/game-fortune-card/GameFortuneCardHome";
import GameFortuneCardResult from "./components/game-fortune-card/GameFortuneCardResult";
import GameFortuneCardSharePage from "./components/game-fortune-card/SharePage";
import GameFortuneCardJoinGroup from "./components/game-fortune-card/JoinGroupPage";
import GameFortuneCardMyGroup from './components/game-fortune-card/MyGroupPage';
//import TestVideo  from "./components/game-fortune-card/TestVideo";

import testParam from "./testParam";

// import { useFeatureRedirect } from "./hooks/useFeatureRedirect";
// import "./utils/axiosConfig";
import withGameExpiry from './withGameExpiry';
import "./config/i18n";
import GameBtsApp from "./components/game-bts/GameBtsApp";
import BtsReceiptPage from "./components/game-bts/pages/ReceiptPage";
import TestScanPage from "./components/game-bts/pages/TestScanPage";
import AdminPage from "./components/game-bts/pages/AdminPage";
import NotFoundRedirect from "./components/common/NotFoundRedirect";
import GameArtToy from "./components/game-arttoy/GameArtToy";
import BigCExhibition from "./components/bigc-exhibition/BigCExhibition";

const Layout = () => {
  // useFeatureRedirect();
  //const { loggedIn, handleLogin } = useLiffAuth();
  //const { loggedIn, liffReady } = useLiffAuth();
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const showHeaderPages = ["/"];
  const shouldShowHeader = showHeaderPages.includes(location.pathname);
  const hasReloadedRef = useRef(false);
  /*const hideHeaderPages = ["/login", "/register"];
  const shouldShowHeader = !hideHeaderPages.includes(location.pathname);*/
  const [userData, setUserData] = useState(null);
  // หน้าที่ต้องซ่อน footer ตามข้อมูลจาก API (เช่น catalog display_mode = 2) สั่งผ่าน setHideFooter
  const [hideFooter, setHideFooter] = useState(false);
  // mini site นิทรรศการถุง Big C (public เหมือน catalog) — เต็มจอ ไม่มี footer ของ LINE
  const isExhibitionPage = location.pathname
    .toLowerCase()
    .startsWith("/bigc_exhibition");
  const shouldShowFooter = !hideFooter && !isExhibitionPage && !(
    location.pathname.startsWith("/bc-coupons/") ||
    location.pathname.startsWith("/missions") ||
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/register") ||
    location.pathname.startsWith("/survey")||
    location.pathname.startsWith("/game")
  );

  const isFullWidthPage =
    isExhibitionPage ||
    location.pathname.startsWith("/catalog") ||
    location.pathname.startsWith("/campaign")||
    location.pathname.startsWith("/game");

  const handleLanguageChange = (lang) => {
    i18n.changeLanguage(lang);
    if (lang === "en") {
      navigate(`/en${location.pathname}`);
    } else {
      navigate(`/${lang}${location.pathname}`);
    }
  };

  /*useEffect(() => {
    const params = new URLSearchParams(location.search);
    const liffState = params.get("liff.state");
    if (liffState) {
      navigate(liffState, { replace: true });
    }
  }, [location.search]);*/

  useEffect(() => {
    //if (!liffReady || !loggedIn) return;
    const params = new URLSearchParams(location.search);

    if (!params) return;

    const feature = params.get("feature");
    const category = params.get("category");
    const couponid = params.get("couponid");
    /*
    const liffstate = params.get("liff.state");
    if (liffstate) {
      //navigate(liffstate, { replace: true });
    }*/
    if (feature) {
      sessionStorage.setItem("cameFromFeature", "true");
    }

    switch (feature) {
      case "register":
        navigate("/register", { replace: true });
        break;
      case "mycoupon":
        navigate("/my-coupons", { replace: true });
        break;
      case "missions":
        navigate("/missions", { replace: true });
        break;
      case "redeemcouponlist":
      case "bccoupons":
        if (category) {
          navigate("/bc-coupons?category=" + category, { replace: true });
        } else {
          navigate("/bc-coupons", { replace: true });
        }
        break;
      case "redeemcoupondetail":
        navigate("/bc-coupons/" + couponid, { replace: true });
        break;
      //default:
      //navigate("/", { replace: true });
    }
  }, [location.search, navigate]);

  // NOTE:
  // ไม่จัดการ liff.state ซ้ำใน App-level สำหรับ mutelu เพราะ useLiffAuth มี flow นี้อยู่แล้ว
  // เพื่อตัด redirect-loop จาก handler ซ้อนกัน (แก้เฉพาะ mutelu; หน้าอื่นไม่เปลี่ยน behavior)

  //Reload เมื่อ ไม่มีการ update 1 ชั่วโมง

  useEffect(() => {
    if (location.pathname === "/" && !hasReloadedRef.current) {
      const lastReload = sessionStorage.getItem("lastReloadTime");
      const now = Date.now();
      const cameFromFeature =
        sessionStorage.getItem("cameFromFeature") === "true";
      const hasBigCard = !!localStorage.getItem("bigCardNumber");

      if (
        cameFromFeature &&
        hasBigCard &&
        (!lastReload || now - parseInt(lastReload) > 3600 * 1000)
      ) {
        sessionStorage.setItem("lastReloadTime", now.toString());
        hasReloadedRef.current = true;
        sessionStorage.removeItem("cameFromFeature"); // ✅ reset flag
        window.location.reload();
      }
    }
  }, [location.pathname]);
  /*
  useEffect(() => {
    if (location.pathname === "/" && !hasReloadedRef.current) {
      const lastReload = sessionStorage.getItem("lastReloadTime");
      const now = Date.now();

      if (!lastReload || now - parseInt(lastReload) > 3600 * 1000) {
        sessionStorage.setItem("lastReloadTime", now.toString());
        hasReloadedRef.current = true;
        window.location.reload();
      }
    }
  }, [location.pathname]);
*/
  useEffect(() => {
    setLastTouchUTMFromURL();
    //migrateLegacyUTMKeys();

    const interval = setInterval(() => {
      sessionStorage.setItem("lastReloadTime", Date.now().toString());
    }, 60 * 10000); // ทุก 10 นาที

    return () => clearInterval(interval); // เคลียร์เมื่อ component unmount
  }, []);

  return (
    <div className="App flex min-h-screen w-full flex-col items-stretch">
      {/*<div className="App flex flex-col min-h-screen justify-center items-center w-full">*/}
      <LoadingBar loading={loading} />

      {/*<div
        className={`relative flex-grow w-full mx-auto ${
          isFullWidthPage ? "" : "max-w-md"
        }`}
      >*/}
      <div
        className={`relative w-full flex-1 mx-auto ${
          isFullWidthPage ? "" : "max-w-md"
        }`}
      >
        <LiffProfileProvider>
          {shouldShowHeader && (
            <ProfileHeader className="z-50 bg-gradient-to-b from-overlay-40 to-overlay-0" />
          )}

          <Routes>
            <Route
              path="/my-coupons"
              element={createElement(withAuthBigPointRedirect(MyCoupons))}
            />
            <Route
              path="/my-coupons/:id"
              element={createElement(withAuthBigPointRedirect(MyCouponDetail))}
            />
            <Route
              path="/bc-coupons"
              element={createElement(withAuthBigPointRedirect(BcCoupons))}
            />
            <Route
              path="/bc-coupons/:id"
              element={createElement(withAuthBigPointRedirect(BcCouponDetail))}
            />
            <Route
              path="/bc_coupons/:id"
              element={createElement(withAuthBigPointRedirect(BcCouponDetail))}
            />
            <Route
              path="/my-bigpoint"
              element={createElement(withAuthBigPointRedirect(MyBigpoint))}
            />
            <Route
              path="/my-bigpoint/scan"
              element={createElement(withAuthBigPointRedirect(Scan))}
            />
            <Route
              path="/my-bigpoint/history"
              element={createElement(withAuthBigPointRedirect(PointHistory))}
            />
            <Route
              path="/missions"
              element={createElement(withAuthBigPointRedirect(Missions))}
            />
            <Route
              path="/missions/:id"
              element={createElement(
                withAuthBigPointRedirect(MissionCateDetail)
              )}
            />
            <Route
              path="/missions/detail/:id"
              element={createElement(withAuthBigPointRedirect(MissionDetail))}
            />
            <Route
              path="/redeemcoupon"
              element={createElement(
                withAuthBigPointRedirect(RedeemCouponModal)
              )}
            />
            <Route
              path="/successbindingform"
              element={createElement(
                withAuthBigPointRedirect(SuccessBindingForm)
              )}
            />

            <Route
              path="/login"
              element={createElement(withAuthRedirect(Login))}
            />

            <Route
              path="/register"
              element={createElement(withAuthRedirect(Register))}
            />

            <Route
              path="/survey"
              element={createElement(withAuthBigPointRedirect(Survey))}
            />

            <Route path="/otp" element={<OtpPage />} />

            <Route path="/scan" element={<Scan />} />

            <Route path="/promotion" element={<Promotion />} />
            {/*<Route path="/section/blogs" element={<Blogs />} />
            <Route path="/section/blogs/:postId" element={<BlogDetail />} />*/}

            {/*<Route path="/campaign/:id/:url" element={<CampaignDetail />} />*/}
            <Route path="/campaign/:friendlyURL" element={<CampaignDetail />} />

            <Route path="/catalog/" element={<CatalogList />} />
            <Route
              path="/catalog/:friendlyURL"
              element={<CatalogViewer setHideFooter={setHideFooter} />}
            />

            {/* When STORIES_REDIRECT_ENABLED, in-app /blogs navigation is redirected
                to the public /stories hub (mirrors the Firebase 301 for direct hits). */}
            <Route
              path="/blogs"
              element={STORIES_REDIRECT_ENABLED ? <StoriesRedirect type="hub" /> : <BlogsList />}
            />
            <Route
              path="/blogs/"
              element={STORIES_REDIRECT_ENABLED ? <StoriesRedirect type="hub" /> : <BlogsList />}
            />
            <Route
              path="/blogs/category/:id"
              element={STORIES_REDIRECT_ENABLED ? <StoriesRedirect type="hub" /> : <BlogsCategory />}
            />
            <Route
              path="/blogs/:friendlyURL"
              element={STORIES_REDIRECT_ENABLED ? <StoriesRedirect type="article" /> : <BlogsDetail />}
            />

            <Route path="/horoscope" element={<Horoscope />} />
            <Route path="/horoscope2" element={<Horoscope2 />} />

            <Route path="/horoscope/lucky-name" element={<LuckyName />} />
            <Route
              path="/horoscope/lucky-name/result"
              element={<LuckyNameResult />}
            />

            <Route path="/horoscope/ascendant" element={<Ascendant />} />
            <Route
              path="/horoscope/ascendant/result"
              element={<AscendantResult />}
            />

            <Route path="/horoscope/tarot" element={<TarotTopicPage />} />
            <Route
              path="/horoscope/tarot/pick"
              element={<TarotPickOnePage />}
            />
            <Route
              path="/horoscope/tarot/result"
              element={<TarotResultPage />}
            />
            <Route
              path="/horoscope/tarot/love"
              element={<TarotPickLovePage />}
            />
            <Route
              path="/horoscope/tarot/result-love"
              element={<TarotResultLovePage />}
            />

            <Route
              path="/horoscope/tarot/ppf"
              element={<TarotPickThreePage />}
            />
            <Route
              path="/horoscope/tarot/result-carousel"
              element={<TarotResultCarousel />}
            />

            <Route path="/line-sticker/:ref" element={<LineSticker />} />

            {/*<Route path="/reward-game-supergirls" element={createElement(withAuthRedirect(RewardScreen))} />
            <Route path="/game/rewards" element={<GameRewards />} />*/}
            <Route path="/game/rewards" element={createElement(withAuthRedirect(GameRewards))} />
            {/*<Route path="/game/supergirls" element={<GameSupergirls />} />*/}
            <Route path="/game/supergirls" element={createElement(withAuthRedirect(GameSupergirls))} />
            
  
            
  {/*       <Route path="/game/fortune-card/result" element={<GameFortuneCardResult />} />
            <Route path="/game/fortune-card/share/:groupCode" element={<GameFortuneCardSharePage />} />
            <Route path="/game/fortune-card/join/:groupCode" element={<GameFortuneCardJoinGroup />} />
            <Route path="/game/fortune-card/my-group" element={<GameFortuneCardMyGroup />} />
             <Route path="/game/fortune-card" element={createElement((GameFortuneCardHome))} />
   */}        
        <Route path="/game/fortune-card" element={createElement((GameFortuneCardHome))} />
          
            {/* <Route path="/game/fortune-card" element={createElement(withGameExpiry(withAuthBigPointRedirect(GameFortuneCardHome)))} />
            <Route path="/game/fortune-card/result" element={createElement(withGameExpiry(withAuthBigPointRedirect(GameFortuneCardResult)))} />
            <Route path="/game/fortune-card/share/:groupCode" element={createElement(withGameExpiry(withAuthBigPointRedirect(GameFortuneCardSharePage)))} />
            <Route path="/game/fortune-card/join/:groupCode" element={createElement(withGameExpiry(withAuthBigPointRedirect(GameFortuneCardJoinGroup)))} /> 
            <Route path="/game/fortune-card/my-group" element={createElement(withGameExpiry(withAuthBigPointRedirect(GameFortuneCardMyGroup)))} /> */}
           
            <Route path="/game/mutelu/*" element={createElement(MuteluApp)} />
            <Route path="/game/bts" element={
              process.env.REACT_APP_ENV === 'dev'
                ? <GameBtsApp />
                : createElement(withAuthBigPointRedirect(GameBtsApp))
            } />
            <Route path="/game/bts/receipt" element={
              process.env.REACT_APP_ENV === 'dev'
                ? <BtsReceiptPage />
                : createElement(withAuthBigPointRedirect(BtsReceiptPage))
            } />

            <Route path="/game/bts/scan-bill" element={<TestScanPage />} />
            {/* legacy redirect: ลิงก์เก่า /test-scan → /scan-bill */}
            <Route path="/game/bts/test-scan" element={<Navigate to="/game/bts/scan-bill" replace />} />
            <Route path="/game/bts/admin" element={<AdminPage />} />

            <Route path="/game-arttoy/serialcode" element={<GameArtToy />} />

            {/* Big C Shopping Bag Exhibition — ไม่ต้อง login; deep link /BigC_Exhibition/:slug */}
            <Route path="/BigC_Exhibition" element={<BigCExhibition />} />
            <Route path="/BigC_Exhibition/:slug" element={<BigCExhibition />} />

            {/* <Route path="/mutelu-main" element={<Navigate to="/game/mutelu/mutelu-main" replace />} /> */}

             {/* <Route path="/game/fortune-card/test-video" element={<TestVideo />} />*/}
            {/*<Route path="/video-feed" element={<VideoFeed />} />*/}

            {/*  debug AuthLine  */}
            <Route path="/is-auth-line" element={<IsAuthLine />} />

            <Route path="/logout" element={<LogoutPage />} />

            <Route path="/" element={<Main />} />

            <Route path="*" element={<NotFoundRedirect />} />
          </Routes>

          {/*  Footer */}
          {/*shouldShowFooter && (
            <div className="pb-20 flex justify-center w-full">
              <Footer className="bg-secondary-background" />
            </div>
          )*/}
          {/* ===== Footer แบบ fixed + Spacer กันเด้ง ===== */}
          {/* Spacer: เว้นที่ด้านล่างตั้งแต่เฟรมแรก เท่ากับความสูง Footer  safe-area */}
          {shouldShowFooter && (
            <div
              aria-hidden
              className="w-full"
              style={{
                paddingBottom: "calc(3.5rem + env(safe-area-inset-bottom))",
              }}
            />
          )}

          {shouldShowFooter && (
            <div
              className="fixed inset-x-0 bottom-0 z-50 flex w-full justify-center"
              style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
            >
              {/* กำหนดความสูงคงที่ให้ Footer container (เช่น 56px = h-14) */}
              <div className="h-14 w-full max-w-md">
                <Footer className="h-full bg-secondary-background" />
              </div>
            </div>
          )}
        </LiffProfileProvider>
      </div>
    </div>
  );
};

function App() {
  usePageTracking();
  return (
    <TranslateProvider>
      <Layout />
    </TranslateProvider>
  );
}

export default App;
